<div class="row mt-3 w-100">
  <app-dashboard-filters
    class="col-12"
    [solution]="selectedSolution"
    [dateRange]="{ start: start, end: end }"
    (changeSolution)="changeSolution($event)"
    (changeDate)="changeDate($event)"
    (changeUnit)="changeUnit($event)"
  />

  @if (rights?.includes('UnitProductCaseStats')) {
    <app-unit-product-stats
      class="col-12"
      [solutionId]="selectedSolution"
      [start]="start"
      [end]="end"
      [selectedUnit]="selectedUnit"
    />
  }
</div>
